<template>
    <div id="stadiafr-jeux-awards">
        <template v-if="is_loading">
            <Loader />
        </template>

        <template v-else>
            <template v-if="error_message">
                <div class="item-error" v-html="error_message"></div>
            </template>

            <template v-else>
                <Header />

                <div class="item-title">
                    <div>Votez pour vos jeux préférés de l'année 2020 !</div>
                </div>
                <div v-for="game in list_of_games" class="item-game" v-bind:class="itemGameBindClass()">
                    <div class="picture">
                        <div>
                            <img v-bind:src="game.picture_url" />
                        </div>
                    </div>
                    <div class="metadatas">
                        <div>
                            <div class="title">{{ game.title }}</div>
                        </div>
                    </div>
                    <div class="results">
                        <div>
                            <div>107</div>
                        </div>
                    </div>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import Loader from '../../components/Loader.vue';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

export default {
    name: "Awards",
    components: {
        Loader,
        Header,
        Footer
    },
    data: () => ({
        is_loading: true,
        error_message: null,
        list_of_games: []
    }),
    methods: {
        itemGameBindClass: function() {
            var obj = { 'liked': Math.round(Math.random()) == 1 };
            return obj;
        },
    },
    mounted() {
        this.$store.dispatch('authentication/getProfile')
            .then((profile) => {
                console.error(profile);
                this.user_profile = profile;

                this.$store.dispatch('games/getAll')
                    .then((games) => {
                        console.error(games);
                        this.list_of_games = games;
                        this.is_loading = false;
                    });
            })
            .catch((error) => {
                console.error(error);
                this.error_message = 'Nous n\'avons pas réussi à récupérer ton profil Discord.<br />Essaie de recharger la page.';
                this.is_loading = false;
            });
    }
}
</script>